import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AgencyTypeModel } from 'src/app/Model/AgencyType.model';
import { AggregatorModel } from 'src/app/Model/Aggregator.model';
import { ResponseData } from 'src/app/Model/Base/Response';
import { RequestModel } from 'src/app/Model/Request.model';
import { VRequestStatusProcessModel } from 'src/app/Model/VRequestStatusProcess.Model';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { crmGeoService } from 'src/app/Services/crm-geo-service/crm-geo-service.service';
import { RequestService } from 'src/app/Services/request/request.service';
import { CustomValidators } from 'src/app/Util/CustomValidators';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { ConnectionTypes } from 'src/app/Model/Enums/ConnectionType.enums';
import { Router } from '@angular/router';
import { PiaFlowsValidationService } from 'src/app/Services/PiaFlowsValidation/pia-flows-validation.service';
import { CreateAgencyRequest } from 'src/app/Model/createAgencyRequest.model';
import { Sections } from 'src/app/Model/Enums/Sections.enum';
import { AgencyTypes } from 'src/app/Model/Enums/AgencyType.enums';
import { Flows } from 'src/app/Model/Enums/Flow.enums';

@Component({
  selector: 'app-agency-overview',
  templateUrl: './agency-overview.component.html',
  styleUrls: ['./agency-overview.component.css']
})
export class AgencyOverviewComponent implements OnChanges {
  public isMobile = false;
  hideSaveButton: boolean = false;
  public Validate;
  public SabreAmadeusBool: boolean;
  public showTooltips: boolean = false;
  @Input() request: RequestModel;
  @Input() lstAggregators: AggregatorModel[];
  @Input() lstAgencyTypes: AgencyTypeModel[];
  @Input() lstStatuses: VRequestStatusProcessModel[];
  allowEdit: boolean;
  newRequest: RequestModel;
  iataPadre: string;
  requestCode: string;
  activeIata: boolean = false;
  @Output() newRequestEvent = new EventEmitter<number>();
  @Output() nextEvent = new EventEmitter();
  @Output() prevEvent = new EventEmitter();
  @ViewChild('popUp', { static: false })
  popUp: ElementRef;
  form = new FormGroup({
    iata: new FormControl('', [Validators.required, Validators.maxLength(7), Validators.minLength(7), CustomValidators.numbersOnlyValidator()]),
    agencyType: new FormControl({ value: '', disabled: true }, [Validators.required]),
    aggregator: new FormControl('', [Validators.required,]),
    email: new FormControl('', [Validators.required, CustomValidators.emailValidator(), Validators.maxLength(500),]),
    iataFather: new FormControl('',),
    DigitoVerificacion: new FormControl('', [Validators.required, Validators.maxLength(1), CustomValidators.numbersOnlyValidator()]),
  });
  constructor(
    breakpointObserver: BreakpointObserver,
    private readonly requestService: RequestService,
    private readonly spinner: NgxSpinnerService,
    private readonly translate: TranslateService,
    private readonly crmGeoService: crmGeoService,
    private readonly lsService : SessionStorageService,
    private readonly router: Router,
    private readonly piaFlowsValidationService: PiaFlowsValidationService
  ) {
    this.DigitoVerificacion.disable();
    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });
  }
  async ngOnChanges() {
    this.allowEdit = this.lstStatuses.some(x => x.IdComponent == Sections.Generalidades);
    if (this.request != null) {
      await this.ValidateIata();
      this.newRequest = Object.assign({}, this.request);
    } else {
      this.newRequest = new RequestModel();
    }
    if (this.newRequest.ConnectionType == environment.request.noIataConnectionType) {
      this.aggregator.disable();
      this.iata.disable();
      this.DigitoVerificacion.disable();
    } else if (this.newRequest.ConnectionType == environment.request.iataConnectionType ||
      this.newRequest.ConnectionType == environment.request.iataNDCConnectionType ||
      this.newRequest.ConnectionType == environment.request.bspArcConnectionType || 
      this.newRequest.AgencyType == AgencyTypes.IATAprimerIngreso || this.newRequest.AgencyType == AgencyTypes.CambioRepresentanteYAdmin) {
      this.aggregator.disable();
      if(this.newRequest.AgencyType == AgencyTypes.IATAprimerIngreso || this.newRequest.AgencyType == AgencyTypes.CambioRepresentanteYAdmin){
        this.showTooltips = true
      }
    }
    this.disableForm();

    if (this.lsService.getLSItem('newiata') != null) {
      this.iataFather?.setValue(this.lsService.getLSItem('newiata'));
      this.iata?.setValue(this.lsService.getLSItem('newiata'));
      if (this.iata?.value != '') {
        await this.ValidateIata(this.lsService.getLSItem('newiata'));
      }
    }

    
    if (this.lsService.getLSItem('newiata') != null) {
      this.iataFather?.setValue(this.lsService.getLSItem('newiata'));
      if (this.request.Iata == undefined) {
        this.DigitoVerificacion.setValue('');
        this.iata?.setValue(this.lsService.getLSItem(''));
      } else {
        this.iata?.setValue(this.request.Iata);
      }
    }
  }

  disableForm(){
    const syncFlows = new Set([Flows.Flujo3_1,Flows.Flujo3_2,Flows.Flujo4_1,Flows.Flujo4_2,Flows.Flujo6_1,Flows.Flujo6_2])
    if (this.request != null && this.request.RequestStatus != null && !this.allowEdit) {
      this.aggregator.disable();
      this.iata.disable();
      this.iataFather.disable();
      this.email.disable();
      this.agencyType.disable();
      this.DigitoVerificacion.disable();
    }
    else if(this.request != null && syncFlows.has(this.request.IdFlow)){
      this.iata.disable();
      this.iataFather.disable();
      this.email.disable();
      this.DigitoVerificacion.disable();
    }
  }

  showIata(): boolean {
    let show = false;
    if (this.newRequest != undefined && this.newRequest.ConnectionType != undefined) {
      show = this.newRequest.ConnectionType == environment.request.iataConnectionType ||
        this.newRequest.ConnectionType == environment.request.syncConnectionType ||
        this.newRequest.ConnectionType == environment.request.bspArcConnectionType||
        this.newRequest.ConnectionType == environment.request.iataNDCConnectionType;
    } else {
      show = false;
    }
    return show;
  }
  showAggregator(): boolean {
    return this.newRequest.ConnectionType == environment.request.syncConnectionType;
  }
  async loadIataPadre() {
    await this.crmGeoService.getIataPadre(this.iata.value).then(res => {
      this.iataPadre = res;
      this.iataFather.setValue(this.iataPadre);
    });
  }
  
  async getEstadoAgencia() {
    await this.crmGeoService.getEstadoAgencia(this.iata.value).then(res => {
      this.activeIata = res == "Activo";
    });
  }
  
  async onSubmit(): Promise<void> {

    this.hideSaveButton = true;
    const ConnectType = this.lsService.getLSItem('type');

    await this.spinner.show();

    if (ConnectType == ConnectionTypes.NoIata) {
      await this.spinner.hide();
      await this.saveRequest();
    } else {
      if (this.lsService.getLSItem('newiata') != null) {
        this.newRequest.IsNewIata = true;
      }

      this.saveRequest();

      switch (this.Validate) {
        case '1':

          await Swal.fire({
            title: this.translate.instant('Request.Messages.UnauthorizedAccess'),
            text: this.translate.instant('Request.Messages.InactiveIATA'),
            icon: 'warning'
          });

          break;
        case '2' :
            const ConnectionType = this.lsService.getLSItem('type');

          if (ConnectionType == ConnectionTypes.AgenciesB2T || ConnectionType == ConnectionTypes.AvSync) {
            await Swal.fire({
              title: this.translate.instant('Request.Messages.UnauthorizedAccessFather'),
              text: this.translate.instant('Request.Messages.InactiveIATAFather'),
              icon: 'warning'
            });

            window.location.replace(`Register?type=4`);
          }
          if (ConnectionType == ConnectionTypes.NoIata || ConnectionType == ConnectionTypes.GDSActivation) {
            await this.saveRequest();
          }

          break;
        case '3':

          await this.saveRequest();
          break;
        case '4':

          await this.saveRequest();
          break;
      }

      await this.spinner.hide();
    }
  }
  async saveRequest() {
    await this.spinner.show();
    if (Number.isNaN(this.newRequest.Id))
      this.newRequest.Id = 0;

    if (this.newRequest.Id == null || this.newRequest.Id == 0) {
      this.newRequest.Language = this.lsService.getLSItem('language') ?? 'es';
    }
    let res: ResponseData;
    this.updateAgencyType(sessionStorage.getItem("agencyType"))
    await this.requestService.postOverview(this.newRequest).then(async resp => {
      if(resp != undefined)
        res = resp;
      else{
        await Swal.fire({
          icon: 'error',
          text: this.translate.instant('Request.Messages.ErrorSaving'),
          showConfirmButton: false,
        }).then(() => {
          window.open(window.location.origin, '_self','noopener,noreferrer');
        })
      }
    });
    await this.spinner.hide();
    await this.verifyResponse(res);
    this.hideSaveButton = false;
    this.nextStep();
  }
  async verifyResponse(res: ResponseData) {

    if (res.head.status.toLowerCase() == 'true') {
      const json = JSON.parse(res.body.response);
      this.newRequestEvent.emit(json.Id);
      this.lsService.setLSItem('IdRequest', json.Id);
      this.lsService.setLSItem('RequestCode', json.RequestCode);
      this.requestCode = json.RequestCode;
      await Swal.fire({
        html: this.popUp.nativeElement,
        width: 500,
        showCloseButton: true,
        showConfirmButton: false,
      });
    } else {
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      }
      );
    }
  }
  async ngAfterViewInit() {
    this.updateAgencyType(sessionStorage.getItem("agencyType"))
  }
  updateAgencyType(value) {
    this.newRequest.AgencyType = value;
  }
  nextStep() {
    this.nextEvent.emit();
  }
  prevStep() {
    this.prevEvent.emit();
  }

  async ValidateIata(Iata?, event?: KeyboardEvent) {
    let controlCheck = event == undefined ? true : event.key != "Control"; 
    try {
      const dv = +this.iata.value % 7;
      this.newRequest.DigitoVerificacion = dv;
    } catch (e) {}
    if (this.iata.value.length == 7 && controlCheck) {
      let validIata: string[] = [];
      let res: ResponseData;
      let CreateUsersFlow = false
      let notValidIATA = false
      let iataIsActive = false
      const newiata = this.lsService.getLSItem('newiata');

      if (Iata != undefined) {
        this.newRequest.Iata = this.lsService.getLSItem('newiata');
        this.newRequest.IsNewIata = true;
      }
      if (newiata == null || Iata != undefined) {
        await this.spinner.show();

        if (!Number.isNaN(this.newRequest.Id)) {
          //Validar el estado del IATA ingresado
          await this.requestService.validIATA(this.newRequest).then(resp => {
            res = resp;
          });
          validIata = JSON.parse(res.body.response.toLowerCase());
          this.Validate = validIata;
          await this.loadAggregators(validIata[1]);
        }
        else {
          this.newRequest.Id = 0
          //Validar el estado del IATA ingresado
          await this.requestService.validIATA(this.newRequest).then(resp => {
            res = resp;
          });
          validIata = JSON.parse(res.body.response.toLowerCase());
          this.Validate = validIata;
          await this.loadAggregators(validIata[1]);
        }
        switch (validIata[0]) {
          case '0':
            await this.spinner.hide();
            //Si el IATA no existe y es un flujo de primer ingreso
            if(this.newRequest.AgencyType == AgencyTypes.IATAprimerIngreso || this.newRequest.AgencyType == AgencyTypes.CambioRepresentanteYAdmin){
              await Swal.fire({
                title: this.translate.instant('Request.Messages.UnauthorizedAccess'),
                text: this.translate.instant('Request.Messages.CreateUsersNotIATAInCrm'),
                icon: 'warning',
                showConfirmButton: true
              }).then( () => {
                this.router.navigate(['Register'])
              });
            }
            break;
          case '1':
            await this.spinner.hide();
            await Swal.fire({
              title: this.translate.instant('Request.Messages.UnauthorizedAccess'),
              text: this.translate.instant('Request.Messages.InactiveIATA'),
              icon: 'warning'
            });

            break;
          case '2' :
              const ConnectionType = this.lsService.getLSItem('type');
              if((this.newRequest.AgencyType == AgencyTypes.IATAprimerIngreso || this.newRequest.AgencyType == AgencyTypes.CambioRepresentanteYAdmin)
                 && this.newRequest.IdFlow == undefined){
                await this.loadIataPadre();
              }
              if (ConnectionType == ConnectionTypes.AgenciesB2T || ConnectionType == ConnectionTypes.AvSync ||  ConnectionType == ConnectionTypes.GDSReactivation) {
                await this.spinner.hide();

                await Swal.fire({
                  title: this.translate.instant('Request.Messages.UnauthorizedAccessFather'),
                  text: this.translate.instant('Request.Messages.InactiveIATAFather'),
                  icon: 'warning'
                });

              }
            
            else if((this.newRequest.AgencyType == AgencyTypes.IATAprimerIngreso || 
              this.newRequest.AgencyType == AgencyTypes.CambioRepresentanteYAdmin) && 
              this.iataFather.value == ""){
              //validar si el iata está activo
              await this.getEstadoAgencia()
              if(this.activeIata)
                CreateUsersFlow = true
              else{
                iataIsActive = true
              }
            }
            else if((this.newRequest.AgencyType == AgencyTypes.IATAprimerIngreso || 
              this.newRequest.AgencyType == AgencyTypes.CambioRepresentanteYAdmin) && 
              this.iataFather.value != ""){
              notValidIATA = true
            }
            
            await this.spinner.hide();
            break;
          case '3':
            if (Iata == undefined) {
              await this.loadIataPadre();
              //si iataFather está vacio significa que es un iata padre
              if((this.newRequest.AgencyType == AgencyTypes.IATAprimerIngreso ||
                 this.newRequest.AgencyType == AgencyTypes.CambioRepresentanteYAdmin) && 
                 this.iataFather.value == "" && this.newRequest.IdFlow == undefined){
                //validar si el iata está activo
                await this.getEstadoAgencia()
                if(this.activeIata)
                  CreateUsersFlow = true
                else{
                  iataIsActive = true
                }
              }
              else if((this.newRequest.AgencyType == AgencyTypes.IATAprimerIngreso || 
                this.newRequest.AgencyType == AgencyTypes.CambioRepresentanteYAdmin) && 
                this.iataFather.value != ""){
                notValidIATA = true
              }
            }
            break;
          case '4':
            if (Iata == undefined) {
              await this.loadIataPadre();
              //si iataFather está vacio significa que es un iata padre
              if((this.newRequest.AgencyType == AgencyTypes.IATAprimerIngreso || 
                this.newRequest.AgencyType == AgencyTypes.CambioRepresentanteYAdmin) && 
                this.iataFather.value == "" && this.newRequest.IdFlow == undefined){
                //validar si el iata está activo
                await this.getEstadoAgencia()
                if(this.activeIata)
                  CreateUsersFlow = true
                else{
                  iataIsActive = true
                }
              }
              else if((this.newRequest.AgencyType == AgencyTypes.IATAprimerIngreso || 
                this.newRequest.AgencyType == AgencyTypes.CambioRepresentanteYAdmin) 
                && this.iataFather.value != ""){
                notValidIATA = true
              }
            }
            break;
        }
        if(CreateUsersFlow){
          //Validar si el iata se encuentra registrado en Av Trade
          let iataRequest = new CreateAgencyRequest()
          iataRequest.iataCode = this.iata.value
          iataRequest.language = this.lsService.getLSItem('language')
          if(this.newRequest.AgencyType == AgencyTypes.IATAprimerIngreso){
            let response = await this.piaFlowsValidationService.canCreateAgency(iataRequest)
            if(!response.succeeded){
              await this.spinner.hide();
              await Swal.fire({
                title: this.translate.instant('Request.Messages.UnauthorizedAccess'),
                text: response.message,
                icon: 'warning',
                showConfirmButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: this.translate.instant("Request.Messages.RememberPassword"),
                showCancelButton: true,
                cancelButtonText: this.translate.instant("Request.Messages.ChangeSuperUser"),
                cancelButtonColor: "#d33",
              }).then( result => {
                if(result.isConfirmed){
                  window.location.href = environment.request.paco;
                }
                else
                  this.router.navigate(['Register'])
              });
            }
          }
          else if(this.newRequest.AgencyType == AgencyTypes.CambioRepresentanteYAdmin){
            let response = await this.piaFlowsValidationService.checkIfAgencyExist(iataRequest)
            if(!response.succeeded){
              await this.spinner.hide();
              await Swal.fire({
                title: this.translate.instant('Request.Messages.UnauthorizedAccess'),
                text: response.message,
                icon: 'warning',
                showConfirmButton: true
              }).then( () => {
                this.router.navigate(['Register'])
              });
            }
          }
        }
        else if(notValidIATA){
          await this.spinner.hide();
          if(this.newRequest.AgencyType == AgencyTypes.IATAprimerIngreso){
            let textMessage = this.translate.instant('Request.Messages.CreateUsersNotValidIATA')
            if(this.lsService.getLSItem("language") == 'es')
              textMessage = textMessage.replace('{UrlconsultasFrecuentes}',environment.consultasFrecuentesEs)
            else if(this.lsService.getLSItem("language") == 'en')
              textMessage = textMessage.replace('{UrlconsultasFrecuentes}',environment.consultasFrecuentesEn)
            else if(this.lsService.getLSItem("language") == 'pt')
              textMessage = textMessage.replace('{UrlconsultasFrecuentes}',environment.consultasFrecuentesPt)
            await Swal.fire({
              title: this.translate.instant('Request.Messages.UnauthorizedAccess'),
              html: textMessage,
              icon: 'warning',
              showConfirmButton: true
            }).then( () => {
              this.router.navigate(['Register'])
            });
          }
          else if(this.newRequest.AgencyType == AgencyTypes.CambioRepresentanteYAdmin){
            await Swal.fire({
              title: this.translate.instant('Request.Messages.UnauthorizedAccess'),
              text: this.translate.instant('Request.Messages.ChangeUserNotValidIATA'),
              icon: 'warning',
              showConfirmButton: true
            }).then( () => {
              this.router.navigate(['Register'])
            });
          }
          
        }
        else if(iataIsActive){
          await this.spinner.hide();
          await Swal.fire({
            title: this.translate.instant('Request.Messages.UnauthorizedAccess'),
            text: this.translate.instant('Request.Messages.CreateUsersInactiveIATA'),
            icon: 'warning',
            showConfirmButton: true
          }).then( () => {
            this.router.navigate(['Register'])
          });
        }
        await this.spinner.hide();
      }

    }
  }


  async loadAggregators(idCountry) {
    await this.crmGeoService.getAgregadores(idCountry).then(res => {
      this.lstAggregators = res;
    });
  }

  public setAggregator(event,evt) {

    if(event.isUserInput){
      if (this.newRequest.AggregatorIdGeo == environment.request.idSabreColombia) {
        this.SabreAmadeusBool = true;
        this.newRequest.IsSabreNdc = true;
      } else {
        this.SabreAmadeusBool = false;
        this.newRequest.IsSabreNdc = false;
      }
  
      if (this.newRequest.AggregatorIdGeo == environment.request.idAmadeusColombia) {
        this.SabreAmadeusBool = true;
        this.newRequest.IsAmadeusNdc = true;
      } else {
        this.SabreAmadeusBool = false;
        this.newRequest.IsAmadeusNdc = false;
      }
      if (this.newRequest.AggregatorIdGeo == environment.request.idTravelPortColombia) {
        this.SabreAmadeusBool = true;
        this.newRequest.IsTravelPortNdc = true;
      } else {
        this.SabreAmadeusBool = false;
        this.newRequest.IsTravelPortNdc = false;
      }


      this.newRequest.AggregatorEmail1 = evt?.Email1;
      this.newRequest.AggregatorEmail2 = evt?.Email2;
      this.newRequest.AggregatorEmail3 = evt?.Email3;
      this.newRequest.AggregatorIdGeo = evt?.AggId;
      this.newRequest.AggregatorNameGeo = evt?.Name;
    }
    
  }

  onKeyPress(event){
    return event.charCode >= 48 && event.charCode <= 57
  }

  disableOptions(){
    const syncFlows = new Set([Flows.Flujo4_1,Flows.Flujo4_2,Flows.Flujo6_1,Flows.Flujo6_2])
    if(this.request != null && syncFlows.has(this.request.IdFlow)){
      return true
    }
    else{
      if(this.SabreAmadeusBool){
        return this.form.invalid || (this.request!=null && this.request.RequestStatus!=null && !this.allowEdit && this.newRequest.ApproveTermsLegal != '')
      }
      else{
        return this.form.invalid || (this.request!=null && this.request.RequestStatus!=null && !this.allowEdit)
      }
    }
  }

  get iata() { return this.form.get('iata'); }
  get iataFather() { return this.form.get('iataFather'); }
  get aggregator() { return this.form.get('aggregator'); }
  get email() { return this.form.get('email'); }
  get agencyType() { return this.form.get('agencyType'); }
  get DigitoVerificacion() { return this.form.get('DigitoVerificacion'); }

}
